import url from "url";
import QS from "querystring";
import * as withConditions from "@insightfulscience/smart-react/hocs/WithConditions";
import Router from "next/router";
import { splitParams } from "./splitParams";
import routes from "../routes";
import { publicConfig } from "../config";

const { ENV } = publicConfig;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isUtmParam = ([param]: [string, ...any]) => /^utm_/i.test(param);
const search = (searchString: string | null) =>
	searchString && `?${searchString}`;
export const ref = (path: string, query: QS.ParsedUrlQueryInput) =>
	`${path}${search(QS.stringify(query))}`;

withConditions.mapServerSideRedirectUrl(
	(pathOrUrl: string, { query }: { query: object }) => {
		const parsedUrl = url.parse(pathOrUrl);

		if (parsedUrl.hostname) return pathOrUrl;

		return url.format({
			...parsedUrl,
			search: null,
			query: {
				...QS.parse(parsedUrl.query || ""),
				...splitParams(query, isUtmParam)[0],
			},
		});
	},
);

export const toPricingPage = () =>
	Router.push({ pathname: routes.pricing.url });

export const toPurchaseSuccessPage = () =>
	Router.push({ pathname: routes.purchase.success });

export const isRouteEnabled = (page: { disabledEnv: string[] }) => {
	const { disabledEnv } = page;

	if (disabledEnv.length) {
		return !disabledEnv.includes(ENV);
	}

	return true;
};
